<template>
  <div style="background-color: #fff; padding: 16px; margin-bottom: 20px">
    <div style="margin-bottom: 16px">
      <a-button type="primary" @click="handleAdd">添加素材项目</a-button>
    </div>

    <!-- 表格 -->
    <MyTable
      ref="table"
      :apiUrl="material_item_index"
      :columns="columns"
      :rowKey="'id'"
    >
      <span slot="cover" slot-scope="text">
        <img
          v-if="text"
          :src="IMGHOST + text"
          style="width: 50px; height: 50px; object-fit: cover; cursor: pointer"
          @click="showPreview(IMGHOST + text)"
        />
        <span v-else>-</span>
      </span>
      <span slot="status" slot-scope="text">
        <a-tag :color="text === 1 ? 'green' : 'red'">
          {{ text === 1 ? "启用" : "禁用" }}
        </a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <a-button type="primary" size="small" @click="handleEdit(record)"
          >编辑</a-button
        >
        <a-popconfirm title="确定要删除吗?" @confirm="handleDelete(record)">
          <a-button type="danger" size="small" style="margin-left: 8px"
            >删除</a-button
          >
        </a-popconfirm>
      </span>
    </MyTable>

    <!-- 模态框 -->
    <a-modal
      :title="modalTitle"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="项目名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入项目名称" />
        </a-form-model-item>

        <a-form-model-item label="分类" required>
          <a-cascader
            v-model="classificationValue"
            :options="categoryOptions"
            :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
            placeholder="请选择分类"
            @change="handleCategoryChange"
            change-on-select
          />
        </a-form-model-item>

        <a-form-model-item label="品牌" prop="brand_id">
          <a-select v-model="form.brand_id" placeholder="请选择品牌">
            <a-select-option
              v-for="brand in brandList"
              :key="brand.id"
              :value="brand.id"
            >
              {{ brand.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="封面" prop="cover">
          <myUpload
            :authApi="material_upload"
            uploadType="img"
            clickType="common"
            :maxLength="1"
            :list="coverUrl"
            @result="handleCoverUpload"
            @remove="handleCoverRemove"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 图片预览模态框 -->
    <a-modal
      title="图片展示"
      :visible="previewVisible"
      :footer="null"
      @cancel="previewVisible = false"
      :width="400"
    >
      <img style="width: 100%" :src="previewImageUrl" />
    </a-modal>
  </div>
</template>

<script>
import MyTable from "@/components/myTable.vue";
import myUpload from "@/components/myUpload.vue";
import {
  material_item_index,
  material_item_add,
  material_item_edit,
  material_item_del,
  material_category_index,
  material_brand_index,
  material_upload,
} from "@/api/material";

export default {
  name: "MaterialItem",
  components: {
    MyTable,
    myUpload,
  },
  data() {
    return {
      IMGHOST: window.IMGHOST || "",
      material_item_index,
      material_upload,
      visible: false,
      confirmLoading: false,
      previewVisible: false,
      previewImageUrl: "",
      modalTitle: "添加素材项目",
      form: {
        id: undefined,
        name: "",
        cate_id: undefined,
        category_id: undefined,
        brand_id: undefined,
        cover: "",
      },
      coverUrl: [],
      categoryOptions: [],
      brandList: [],
      classificationValue: [],
      rules: {
        name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        brand_id: [
          { required: true, message: "请选择品牌", trigger: "change" },
        ],
      },
      columns: [
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
          width: 150,
          fixed: "left",
        },
        { title: "ID", dataIndex: "id", width: 80 },
        { title: "项目名称", dataIndex: "name" },
        {
          title: "封面",
          dataIndex: "cover",
          scopedSlots: { customRender: "cover" },
        },
        { title: "排序", dataIndex: "sort" },
        // { title: "状态", dataIndex: "status", scopedSlots: { customRender: "status" } },
        { title: "创建时间", dataIndex: "create_at" },
        { title: "更新时间", dataIndex: "update_at" },
      ],
    };
  },
  mounted() {
    this.fetchCategories();
    this.fetchBrands();
  },
  methods: {
    showPreview(url) {
      this.previewImageUrl = url;
      this.previewVisible = true;
    },
    fetchCategories() {
      material_category_index({ page: 1, limit: 1000 }).then((res) => {
        // We only need level 1 and level 2 for Material Item creation
        this.categoryOptions = res.map((cat) => ({
          id: cat.id,
          name: cat.name,
          children: cat.children
            ? cat.children.map((sub) => ({
                id: sub.id,
                name: sub.name,
                isLeaf: true,
              }))
            : [],
        }));
      });
    },
    fetchBrands() {
      material_brand_index({ page: 1, limit: 1000 }).then((res) => {
        this.brandList = res || [];
      });
    },
    handleCategoryChange(value) {
      if (value.length >= 1) {
        this.form.cate_id = value[0];
      } else {
        this.form.cate_id = undefined;
      }
      if (value.length >= 2) {
        this.form.category_id = value[1];
      } else {
        this.form.category_id = undefined;
      }
    },
    handleCoverUpload(result) {
      this.form.cover = result.url;
      this.coverUrl = [result.url];
    },
    handleCoverRemove() {
      this.form.cover = "";
      this.coverUrl = [];
    },
    handleAdd() {
      this.modalTitle = "添加素材项目";
      this.classificationValue = [];
      this.coverUrl = [];
      this.form = {
        id: undefined,
        name: "",
        cate_id: undefined,
        category_id: undefined,
        brand_id: undefined,
        cover: "",
      };
      this.visible = true;
    },
    handleEdit(row) {
      this.modalTitle = "编辑素材项目";
      this.form = {
        id: row.id,
        name: row.name,
        cate_id: row.cate_id,
        category_id: row.category_id,
        brand_id: row.brand_id,
        cover: row.cover,
      };

      this.classificationValue = [];
      if (row.cate_id) this.classificationValue.push(row.cate_id);
      if (row.category_id) this.classificationValue.push(row.category_id);

      this.coverUrl = row.cover ? [row.cover] : [];
      this.visible = true;
    },
    handleDelete(record) {
      material_item_del({ id: record.id }).then(() => {
        this.$message.success("删除成功");
        this.$refs.table.getList();
      });
    },
    handleOk() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.form.cate_id) {
            this.$message.warning("请选择分类");
            return;
          }

          this.confirmLoading = true;
          const api = this.form.id ? material_item_edit : material_item_add;
          api(this.form)
            .then(() => {
              this.$message.success(this.form.id ? "修改成功" : "添加成功");
              this.visible = false;
              this.$refs.table.getList();
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>
